import { useContext } from "react";
import SchemaModulesContext from "./SchemaModulesContext";

export function useSchemaModules() {
    return useContext(SchemaModulesContext);
}
